import React from 'react';

const Button = ({ 
  children, 
  onClick, 
  type = 'button', 
  disabled = false, 
  variant = 'primary', 
  size = 'medium',
  className = '',
  ...props 
}) => {
  const baseClasses = 'inline-flex items-center justify-center font-medium rounded-md transition-custom focus:outline-none focus:ring-2 focus:ring-offset-2 font-sans';
  
  const variants = {
    primary: 'bg-brand-primary text-white hover:bg-brand-primary-dark focus:ring-brand-primary disabled:bg-brand-primary/50',
    secondary: 'bg-brand-secondary text-white hover:bg-brand-secondary/90 focus:ring-brand-secondary disabled:bg-brand-secondary/50',
    tertiary: 'bg-surface-secondary text-primary hover:bg-light focus:ring-brand-primary disabled:bg-surface-secondary/50',
    warning: 'bg-warning-500 text-white hover:bg-warning-600 focus:ring-warning-500 disabled:bg-warning-500/50',
    danger: 'bg-error-500 text-white hover:bg-error-600 focus:ring-error-500 disabled:bg-error-500/50',
    success: 'bg-success-500 text-white hover:bg-success-600 focus:ring-success-500 disabled:bg-success-500/50',
    outline: 'border border-brand-primary bg-surface-primary text-primary hover:bg-brand-primary-dark hover:text-white focus:ring-brand-primary disabled:bg-surface-primary/50'
  };
  
  const sizes = {
    sm: 'px-3 py-1.5 text-sm',
    medium: 'px-4 py-2 text-sm',
    lg: 'px-6 py-3 text-base'
  };
  
  const variantClasses = variants[variant] || variants.primary;
  const sizeClasses = sizes[size] || sizes.medium;
  const disabledClasses = disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer';
  
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${baseClasses} ${variantClasses} ${sizeClasses} ${disabledClasses} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
